import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import { QuestionEditorComponent } from './components/question-editor/question-editor.component';
import { AnswerFilterPipe } from './pipes/answer-filter.pipe';
import { CategoryAdderComponent } from './components/category-adder/category-adder.component';
import { QuestionEditorBulkComponent } from './components/question-editor-bulk/question-editor-bulk.component';
import { TypeRewardAdderComponent } from './components/type-reward-adder/type-reward-adder.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { QuestionEditorImportComponent } from './components/question-editor-import/question-editor-import.component';
import { RewardMethodAdderComponent } from './components/reward-method-adder/reward-method-adder.component';
import { ValueArrayPipe } from './pipes/value-array.pipe';
import { QuestionEditorGroupEditComponent } from './components/question-editor-group-edit/question-editor-group-edit.component';


@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NzIconModule,
        SearchPipe,
        QuestionEditorComponent,
        QuestionEditorBulkComponent,
        QuestionEditorImportComponent,
        CategoryAdderComponent,
        QuestionEditorGroupEditComponent,
        TypeRewardAdderComponent,
        RewardMethodAdderComponent,
        NgxPermissionsModule,
        ValueArrayPipe
    ],
    imports: [
        RouterModule,
        CommonModule,
        NzIconModule,
        NzToolTipModule,
        ReactiveFormsModule,
        NzFormModule,
        FormsModule,
        NzInputModule,
        NzSelectModule
    ],
    declarations: [
        SearchPipe,
        QuestionEditorComponent,
        AnswerFilterPipe,
        CategoryAdderComponent,
        QuestionEditorBulkComponent,
        TypeRewardAdderComponent,
        QuestionEditorImportComponent,
        RewardMethodAdderComponent,
        ValueArrayPipe,
        QuestionEditorGroupEditComponent
    ],
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
